export const OPENING_TIME = '09:30 AM';
export const CLOSING_TIME = '09:30 PM';

export const BOOKING_LINK = 'https://tesbarber.simplybook.it/v2/#book';

export const ABOUT = 'about';
